export interface RunRefreshAttempt {
  signal: AbortSignal;
  isCurrent(): boolean;
  finish(): void;
}

export interface RunRefreshCoordinator {
  start(options?: { replace?: boolean; timeoutMs?: number }): RunRefreshAttempt | null;
  cancel(): void;
}

export function createRunRefreshCoordinator(): RunRefreshCoordinator {
  let sequence = 0;
  let activeController: AbortController | null = null;
  let activeTimeout: ReturnType<typeof setTimeout> | null = null;

  const clearActiveTimeout = (): void => {
    if (activeTimeout !== null) clearTimeout(activeTimeout);
    activeTimeout = null;
  };

  return {
    start(options = {}): RunRefreshAttempt | null {
      if (activeController && !options.replace) return null;
      activeController?.abort();
      clearActiveTimeout();
      const controller = new AbortController();
      const attemptSequence = ++sequence;
      activeController = controller;
      if (options.timeoutMs !== undefined) {
        activeTimeout = setTimeout(
          () => controller.abort(new Error("Run request timed out")),
          options.timeoutMs,
        );
      }
      return {
        signal: controller.signal,
        isCurrent: () => attemptSequence === sequence,
        finish: () => {
          if (attemptSequence !== sequence) return;
          clearActiveTimeout();
          activeController = null;
        },
      };
    },
    cancel(): void {
      sequence += 1;
      activeController?.abort();
      clearActiveTimeout();
      activeController = null;
    },
  };
}
